/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { PaymentServiceUIConfig } from './types'
import { RequiredConfigError } from './errors'
import { requiredEnvVars } from './required'

const readEnv = (param: string): string | undefined => import.meta.env[param]

// just a little function to throw error
const validateConfig = () => {
  requiredEnvVars.forEach((param) => {
    if (!readEnv(param)) {
      throw new RequiredConfigError(param)
    }
  })
}

export const envConfig = (): PaymentServiceUIConfig => {
  validateConfig()

  return {
    apiUrl: import.meta.env.REACT_APP_PAYMENT_API_DOMAIN!,
    keycloak: {
      baseUrl: import.meta.env.REACT_APP_KEYCLOAK_BASE_URL || ''
    },
    msal: {
      clientId: import.meta.env.REACT_APP_MSAL_CLIENT_ID!,
      tenant: import.meta.env.REACT_APP_MSAL_TENANT!
    },
    sentry: {
      dsn: import.meta.env.REACT_APP_SENTRY_DSN
    },
    unzer: {
      merchantId: import.meta.env.REACT_APP_UNZER_MERCHANT_ID!
    },
    adyen: {
      clientKey: import.meta.env.REACT_APP_ADYEN_CLIENT_KEY!,
      merchantAccount: import.meta.env.REACT_APP_ADYEN_MERCHANT_ACCOUNT!,
      environment: import.meta.env.REACT_APP_ADYEN_ENVIRONMENT!
    },
    documentService: {
      url: import.meta.env.REACT_APP_DOCUMENT_SERVICE_URL!
    },
    app: {
      url: import.meta.env.REACT_APP_APP_URL!
    },
    gb: {
      adminUi: import.meta.env.REACT_APP_GB_ADMIN_UI!
    }
  }
}
